// Detects embedded / in-app browsers (social webviews) where Google OAuth is
// blocked with "Error 403: disallowed_useragent". Used to swap the Google
// sign-in button for an "open in a real browser" + magic-link card.
export function isInAppBrowser(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const patterns: RegExp[] = [
    /FBAN/,
    /FBAV/,
    /FB_IAB/,
    /Messenger/,
    /Instagram/,
    /Line\//i,
    /Twitter/,
    /TikTok/i,
    /musical_ly/i,
    /Bytedance/i,
    /WhatsApp/i,
    /LinkedInApp/i,
    /; wv\)/,
  ];
  return patterns.some((re) => re.test(ua));
}

export function isAndroid(): boolean {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent || "");
}

export function isIOS(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return true;
  // iPadOS 13+ masquerades as desktop Safari but still has touch.
  return (
    /Macintosh/.test(ua) &&
    typeof document !== "undefined" &&
    "ontouchend" in document
  );
}

// Build an Android intent:// URL that reopens the current page in Chrome,
// breaking out of the social app's in-app webview (where Google OAuth fails).
// Chrome is preinstalled on virtually all Android devices; `browser_fallback_url`
// is a safety net so the OS still opens the page if Chrome is somehow absent.
export function androidChromeIntentUrl(): string {
  if (typeof window === "undefined") return "";
  const url = new URL(window.location.href);
  const scheme = url.protocol.replace(":", "");
  const fallback = encodeURIComponent(url.href);
  return `intent://${url.host}${url.pathname}${url.search}#Intent;scheme=${scheme};package=com.android.chrome;S.browser_fallback_url=${fallback};end`;
}
